export const trimStationLabels = (label: string): string => {
  return label?.replace(" DLR Station", "").replace(" Underground Station", "");
};
